export const START_SEARCH_FROM = 2;
export const MAIN_LAYOUT_ID = 'mainLayout';
export const SECONDARY_LAYOUT_ID = 'secondaryLayout';
export const HEAD_LAYOUT_ID = 'headLayout';
export const OVERLAPPING_HEAD_LAYOUT_ID = 'overlappingHeadLayout';

export const getCategoryId = (id: string) => {
  return `category_${id}`;
};

export const getAnswerId = (id: string) => {
  return `answer_${id}`;
};
